import {bind} from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const style = require('@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/tabsPanel/SpreadsheetNameEditor.less');
const cx = classnames.bind(style);

export type OnRefHandler = (element:HTMLDivElement) => void;
export type OnTextChangedHandler = (value:string) => void;
export type EditCompleteHandler = () => void;
export type EditCancelledHandler = () => void;
export type ValidateFunction = (value:string) => boolean;

interface ISheetNameEditorProps
{
    initialValue:string;
    className?:string;
    isValid?:boolean;
    onRef?:OnRefHandler;
    onTextChanged?:OnTextChangedHandler;
    validateFn?:ValidateFunction;
    onComplete?:EditCompleteHandler;
    onCancel?:EditCancelledHandler;
}

@observer
export class SpreadsheetNameEditor extends React.Component<ISheetNameEditorProps>
{
    public defaultProps:Partial<ISheetNameEditorProps> = {
        isValid: true,
        onRef: () => null,
        onTextChanged: () => null,
        validateFn: (value:string) => true,
        onComplete: () => null,
        onCancel: () => null,
    };

    private _element:HTMLElement = null;

    @bind
    private _onElementRef(element:HTMLDivElement):void
    {
        if( !element )
            return;

        element.innerText = this.props.initialValue;
        element.focus();
        document.execCommand('selectAll',false,null);
        this._element = element;
        this.props.onRef(element);
    }

    @bind
    private _onInput(event:React.FormEvent<HTMLDivElement>):void
    {
        const text = this._element.textContent;
        const valid = this.props.validateFn(text);
        let errorClass = cx('error');
        if( !valid )
        {
            if( !this._element.classList.contains(errorClass) )
            {
                this._element.classList.add(errorClass);
            }
        }
        else
        {
            this._element.classList.remove(errorClass);
        }
        this.props.onTextChanged(text);
    }

    @bind
    private _onBlur():void
    {
        this.props.onComplete();
    }

    @bind
    private _onKeyPress(event:React.KeyboardEvent<HTMLDivElement>):void
    {
        if( event.key.toLowerCase() === 'enter' )
        {
            event.preventDefault();
            event.stopPropagation();
            this.props.onComplete();
        }
        else if( event.key.toLowerCase() === 'escape' )
        {
            event.preventDefault();
            event.stopPropagation();
            this.props.onCancel();
        }
    }

    public render():JSX.Element
    {
        return <div
            ref={this._onElementRef}
            contentEditable={true}
            className={cx('editor')}
            onInput={this._onInput}
            onBlur={this._onBlur}
            onKeyDownCapture={this._onKeyPress} />;
    }
}
